import * as React from "react";
import { useAuth } from "src/modules/Auth/hooks/useAuth";
import { sessionTime } from "src/modules/Auth/helpers/sessionTime";

type IsSessionExpiredContextType = [boolean, React.Dispatch<React.SetStateAction<boolean>>]
const IsSessionExpiredContext = React.createContext([] as any as IsSessionExpiredContextType);

const IsSessionExpiredProvider = ({ children }) => {
  const timeoutId = React.useRef<NodeJS.Timeout>()
  const [isAuthExpired, setAuthExpiration] = React.useState(false)
  const [authState, actions] = useAuth();
  const clearCurrentTimeout = () => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current)
    }
  }
  React.useEffect(() => {
    const { isAuthenticated, isExpired, timeLeft } = sessionTime(authState)
    if (isAuthenticated) {
      if (isExpired && !timeoutId.current) {
        actions.logout()
      } else {
        setAuthExpiration(false);
        timeoutId.current = setTimeout(() => setAuthExpiration(true), timeLeft)
      }
    }
    return () => {
      clearCurrentTimeout()
    }
  }, [authState.idToken]);
  return (
    <IsSessionExpiredContext.Provider value={[isAuthExpired, setAuthExpiration]}>
      {children}
    </IsSessionExpiredContext.Provider>
  )
}
export {
  IsSessionExpiredContext,
  IsSessionExpiredProvider,
};